var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgClockIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_7538_111693)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_7538_111693)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.8898 5.75009L5.14728 5.02661L5.91762 6.36553C4.12431 8.01074 3.00009 10.3736 3.00009 12.9991C3.00009 17.9697 7.02953 21.9991 12.0001 21.9991C16.9707 21.9991 21.0001 17.9697 21.0001 12.9991C21.0001 10.3724 19.8748 8.00854 18.0801 6.36324L18.849 5.02683L20.1065 5.75034L21.1039 4.01678L16.77 1.5233L15.7726 3.25685L17.1154 4.02943L16.455 5.17726C15.1415 4.42752 13.6208 3.99913 12.0001 3.99913C10.3782 3.99913 8.8565 4.42815 7.5423 5.1789L6.88083 4.02921L8.22368 3.25661L7.22628 1.52305L2.8924 4.01654L3.8898 5.75009ZM11.0001 7.49902L11.0001 12.999L11.0001 13.499L11.0001 14.199C11.0001 14.6409 11.3583 14.999 11.8001 14.999L16.5001 14.999C16.7763 14.999 17.0001 14.7752 17.0001 14.499L17.0001 13.499C17.0001 13.2229 16.7763 12.999 16.5001 12.999L13.0001 12.999L13.0001 7.49902C13.0001 7.22288 12.7763 6.99902 12.5001 6.99902L11.5001 6.99902C11.224 6.99902 11.0001 7.22288 11.0001 7.49902Z",
    fill: "white"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_7538_111693"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_7538_111693"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClockIcon);
export default __webpack_public_path__ + "static/media/Clock Icon.8c1c1f0ded5149475b683e2c1bac1f87.svg";
export { ForwardRef as ReactComponent };